import { render } from "./ReCaptchaPolicy.vue?vue&type=template&id=747e7605"
import script from "./ReCaptchaPolicy.vue?vue&type=script&lang=js"
export * from "./ReCaptchaPolicy.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__